import { IconCrate } from '~/design-system';
import type { ModuleDefinition } from '~/platform/registry/types';

export const purchasingModule: ModuleDefinition = {
  id: 'purchasing',
  i18nNamespace: 'purchasing',
  requires: { subject: 'purchase', action: 'read' },

  nav: {
    labelKey: 'purchasing:nav',
    icon: IconCrate,
    to: 'purchasing',
    group: 'move',
    order: 10,
  },

  routes: [{ path: 'purchasing', component: () => import('./PurchasingPage') }],

  commands: [
    {
      id: 'purchasing.list',
      labelKey: 'purchasing:shoppingList',
      groupKey: 'purchasing:title',
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/purchasing`),
    },
    {
      id: 'purchasing.generate',
      labelKey: 'purchasing:generate',
      groupKey: 'purchasing:title',
      requires: { subject: 'purchase', action: 'create' },
      run: ({ businessSlug, navigate }) => navigate(`/b/${businessSlug}/purchasing?generate=1`),
    },
  ],
};
